import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EDocsApiService } from './edocs-api.service';
import { EDocsEffects } from './edocs.effects';
import { eDocsInitialState, eDocsReducer } from './edocs.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('eDocs', eDocsReducer, {
      initialState: eDocsInitialState
    }),
    EffectsModule.forFeature([EDocsEffects])
  ],
  providers: [EDocsApiService]
})
export class EDocsStoreModule {}
